import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PreventiveMaintenanceStandaloneService } from 'src/app/_services/preventive-maintenance-standalone.service';
import moment from "moment-timezone";
@Component({
    selector: 'app-adjust-date-plan',
    templateUrl: './adjust-date-plan.component.html',
    styleUrls: ['./adjust-date-plan.component.scss'],
    standalone: false
})
export class AdjustDatePlanComponent implements OnInit {
  data: any
  tomorrow!: Date;
  nextMaintenanceDateTime:any

  constructor(
    public modalRef: BsModalRef,
    private preventiveMaintenanceStandaloneService: PreventiveMaintenanceStandaloneService
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    this.getFutureDate();
  }
/****************************************** Get Future Date *****************************/
getFutureDate() {
  const t = new Date();
     t.setHours(0,0,0,0);
    t.setDate(t.getDate() + 1);
    this.tomorrow = t;
}
isSubmitDisabled(): boolean {
  return !this.nextMaintenanceDateTime;
}
/****************************************** Update Next Maintenance Date *****************************/
updateNextMaintenanceDate() {
  var planType= this.data.planType == 'ASSET' ? 'asset' : 'site';
  const payload = {
    "nextMaintenanceDateTime": moment.tz( this.nextMaintenanceDateTime, this.data.timezone).format(),
    id: this.data.id
  }
  this.preventiveMaintenanceStandaloneService.adjustNextMaintenanceDate(payload, planType).subscribe((res:any) => {
    this.modalRef.hide();
    //this.preventiveMaintenanceStandaloneService.planDateUpdated.next(true);
  }, (error:any) => {
    console.error('Error updating next maintenance date:', error);
  }); 
}
}